import {Component, Input, Output, EventEmitter, OnInit, OnChanges, ElementRef, HostListener, ViewChild, AfterViewInit} from '@angular/core';
import {EnvironmentService, LocalStorageService} from '@nw/ui-core-shared/services';
import { Vehicle } from '../../../shared/domain/vehicle';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { fadeIn } from '@nw/ui-core-shared/animations/animations';
import {VehicleFilterService} from '../../../shared/services/vehicle-filter.service';
import {MainStoreService} from '@nw/ui-core-shared/store/main-store.service';
import {VehicleSortService} from '../../../shared/services/vehicle-sort.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {PlatformLocation} from '@angular/common';
import { MfeRedirectionService } from '@nw/ui-core-shared/services/mfe-redirection.service';

@Component({
    selector   : 'nw-vehicle-list-item-v1',
    templateUrl: './vehicle-list-item-v1.component.html',
    animations : [fadeIn]
})
export class VehicleListItemV1Component implements OnInit, OnChanges, AfterViewInit {
    @Input() vehicle: Vehicle;
    @Output() bidSelected = new EventEmitter();
    @Output() showVehicleRemove: EventEmitter<any> = new EventEmitter();
    @ViewChild('iconsHolder') iconsHolder: ElementRef;
    buyerOaUrl;
    imgCdn;
    navigateToClassicVDP;
    isClassicVDP = false;
    showInformation = false;
    isConsignorGroup;
    isDeleteOpen = false;
    isRunList;
    runListIndex;
    isRunList$;
    isLiveBlock;
    isLiveBlock$;
    isDealerBlock;
    liveBlockIndex;
    dealerBlockIndex;
    isImgLoaded = false;
    imagePlaceholder;
    currentPath; // defined where the user
    prevNextURI: string;
    sortQueryParams;
    filteredHandler;
    userId;
    saleEvents = {
        runList    : 'run_list',
        liveBlock  : 'live_block',
        dealerBlock: 'dealer_block'
    };
    showcolumnFullForRLLB = false;
    modalRef: BsModalRef;

    constructor(private environmentService: EnvironmentService,
                private router: Router, private bsModalService: BsModalService, private location: PlatformLocation,
                private activatedRoute: ActivatedRoute, private localStorageService: LocalStorageService, private vehicleSortService: VehicleSortService,
                private vehicleFilterService: VehicleFilterService,
                private mainStoreService: MainStoreService,
                private mfeRedirectionService: MfeRedirectionService) {
        location.onPopState( () => {
            // reset the modal when back button pressed
            if (this.modalRef) {
                this.modalRef.hide()
            }
        });
    }

    ngOnInit() {
        this.mainStoreService.getStore().select(state => state.appPrincipal)
            .subscribe(principal => {
                this.userId = principal.getUserId();
            });
        this.captureDatafromLocalStorage();
        this.getInitialSaleEventStates();
        this.currentPath = window.location.origin;
        this.buyerOaUrl = this.environmentService.getEnvironment().interfacePath.buyerOa;
        this.imgCdn = this.environmentService.getEnvironment().utilPath.imagesCdn;
        this.navigateToClassicVDP = `${this.buyerOaUrl}/detail.html?vehicleId=${this.vehicle.originalVehicleId}&from=watchlistPage&section=watching`;
        this.isClassicVDP = this.environmentService.getEnvironment().isClassicVDP;
        this.imgPreload();
        this.imagePlaceholder = `${this.environmentService.getEnvironment().utilPath.asset}/img/Image_Holder_EN.svg`;
        this.isConsignorGroupSameAsSellerFn();
        this.isRunListLiveBlockPresent();
        this.getBadges();
    }

    ngOnChanges() {
        this.refreshSaleEventStates();
        this.getBadges();
    }
    ngAfterViewInit() {
        this.captureDatafromLocalStorage();
    }

    private getInitialSaleEventStates() {
        this.isRunList = this.vehicle.saleEventStates.indexOf(this.saleEvents.runList) >= 0;
        this.isLiveBlock = this.vehicle.saleEventStates.indexOf(this.saleEvents.liveBlock) >= 0;
        this.isDealerBlock = this.vehicle.saleEventStates.indexOf(this.saleEvents.dealerBlock) >= 0;
        this.dealerBlockIndex = this.vehicle.saleEventStates.indexOf(this.saleEvents.dealerBlock);
        this.runListIndex = this.vehicle.saleEventStates.indexOf(this.saleEvents.runList);
        this.liveBlockIndex = this.vehicle.saleEventStates.indexOf(this.saleEvents.liveBlock);
    }

    findMinIndexForRunLive() {
        let minVal =  Math.min(this.runListIndex, this.liveBlockIndex);
        if (minVal === -1 ) {
            minVal = Math.max(this.runListIndex, this.liveBlockIndex)
        }
        return minVal;
    }
    private refreshSaleEventStates() {
        this.isRunList$   =  this.vehicle.saleEventStates.indexOf(this.saleEvents.runList)   >= 0 ? true : this.isRunList;
        this.isLiveBlock$ =  this.vehicle.saleEventStates.indexOf(this.saleEvents.liveBlock) >= 0 ? true : this.isLiveBlock;
    }

    imgPreload() {
        let c = new Image();
        c.src = this.vehicle.imageThumb ? this.imgCdn + this.vehicle.imageThumb.replace(".jpg", "_dt.jpg") : "";
        c.onload = () => {
            this.isImgLoaded = true;
        };
    }

    updateView(key, $event): void {
        this[key] = $event;
    }

    navigateToVdp(nwVehicleId: string): void {
        if (this.isClassicVDP) {
            window.open(this.navigateToClassicVDP, '_self');
        } else if(!!this.mfeRedirectionService.ifRedirectionToMfeRequired(window.location.origin, '/vdp')) {
            let queryParams = encodeURI(`vehicleId=${nwVehicleId}&criteria=${this.prevNextURI}`);
            let routeBase = window.location.pathname.split('/watchlist')[0];
            window.open(`${routeBase}/mfe/vdp?${queryParams}`, '_self');
        } else {
            this.router.navigate(['../vdp/' + nwVehicleId], {queryParams: {criteria: this.prevNextURI }, relativeTo: this.activatedRoute})
                .then()
                .catch(err => {
                    Observable.throw(err);
                });
        }
    }

    showVehicleRemoveModal($event) {
        this.showVehicleRemove.emit({vehicle: this.vehicle, element: $event.currentTarget});
    }

    isIconAvailable(value: string) {
        if (this.vehicle.icons) {
            return this.vehicle.icons.indexOf(value) > -1;
        } else {
            return false;
        }
    }
    toggleIconInfo(template) {
        this.modalRef = this.bsModalService.show(template, {class: 'modal-md'});
    }

    @HostListener('document:click', ['$event']) documentClick(event) {
        if (!this.iconsHolder.nativeElement.contains(event.target))  {
            this.showInformation = false;
        }
    }
    captureDatafromLocalStorage() {
        this.filteredHandler = this.localStorageService.getLocalObject('NW.wl-filter');
        this.sortQueryParams = this.vehicleSortService.getSortByQuery();
        this.prevNextURI = encodeURIComponent(`${this.currentPath}/api/watchlist/${this.userId}/vehicles/${this.vehicle.nwVehicleId}/nextPreviousVehicles?
            ${this.sortQueryParams}`) + this.filteredHandler;
    }

    isConsignorGroupSameAsSellerFn() {
        if ( this.vehicle.consignorOrganizationName && this.vehicle.sellerOrganizationName) {
            const ConsignorGroup =  this.vehicle.consignorOrganizationName.replace(/\s+/g, '' );
            const SellerGroup =  this.vehicle.sellerOrganizationName.replace(/\s+/g, '' );
            this.isConsignorGroup =  ConsignorGroup.toUpperCase() === SellerGroup.toUpperCase();
        }
    }

    isRunListLiveBlockPresent() {
        const salesArr = this.vehicle.saleEventStates;
        if (salesArr.length > 1 && this.isRunList && this.isLiveBlock && !this.isDealerBlock) {
                this.showcolumnFullForRLLB = true;
        }
    }

    getBadges() {
        if (this.vehicle.recommendationBadges) {
            this.vehicle.recommendationBadges.forEach( function(data) {
                if (data.reason_id === '1') {
                    data.src = 'lowLot_drivin'
                } else if (data.reason_id === '2') {
                    data.src = 'recentSuccess_drivin'
                } else if (data.reason_id === '3') {
                    data.src = 'underSupplied_drivin'
                } else if (data.reason_id === '4') {
                    data.src = 'pastPurchase_drivin'
                 } else if (data.reason_id === '5') {
                    data.src = 'recentlyViewed_drivin'
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/vehicle-list-item-v1/vehicle-list-item-v1.component.ts